import React, { useMemo } from 'react';
import type { Notice as Interface } from '../../design/components';
import { randomMessageForTone, ShimmerText, StaticText } from '../shared/notice';

export const Notice: React.FC<Interface> = ({ state, tone = 'loading', animated, detail }) => {
  // useMemo([tone]), not useState: App.tsx swaps gates that render the
  // same Notice element type but different tones (e.g. loading →
  // unknown when discover resolves with no match). React reconciles
  // the instance, so a once-off useState initializer would freeze the
  // message on the original tone's pool. useMemo re-picks when tone
  // actually changes, but stays stable across re-renders otherwise.
  const fallback = useMemo(() => randomMessageForTone(tone), [tone]);
  const [text, Icon] = state?.[0] ? [state[0], null] : fallback;
  const shouldAnimate = animated ?? tone === 'loading';

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '12px', padding: '2rem' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        {shouldAnimate
          ? <ShimmerText text={text} Icon={Icon} colors={['#6b7280', '#d1d5db']} iconColor="#9ca3af" />
          : <StaticText text={text} Icon={Icon!} color="#6b7280" iconColor="#9ca3af" />
        }
      </div>
      {detail && <span style={{ color: '#9ca3af', fontSize: '0.875rem' }}>{detail}</span>}
    </div>
  );
};
